module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "responsible-form"
  }, [_c('div', {
    staticClass: "flex-40 mx-1 mb-2",
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "Nombre responsable de recoger"
    },
    model: {
      value: (_vm.responsible.name),
      callback: function($$v) {
        _vm.$set(_vm.responsible, "name", $$v)
      },
      expression: "responsible.name"
    }
  }), _vm._v(" "), (_vm.$v.responsible.name.$invalid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("El nombre es requerido")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-40 mx-1 mb-2",
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "Apellido responsable de recoger"
    },
    model: {
      value: (_vm.responsible.lastname),
      callback: function($$v) {
        _vm.$set(_vm.responsible, "lastname", $$v)
      },
      expression: "responsible.lastname"
    }
  }), _vm._v(" "), (_vm.$v.responsible.lastname.$invalid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("El apellido es requerido")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-40 mx-1 mb-2",
    attrs: {
      "prop": "dni"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "DNI"
    },
    model: {
      value: (_vm.responsible.dni),
      callback: function($$v) {
        _vm.$set(_vm.responsible, "dni", $$v)
      },
      expression: "responsible.dni"
    }
  }), _vm._v(" "), (!_vm.$v.responsible.dni.required) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("El DNI es requerido")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "flex-40 mx-1 mb-2",
    attrs: {
      "prop": "phone"
    }
  }, [_c('el-input', {
    staticClass: "qtc-input",
    style: (("background-color:" + (_vm.globalColors.border))),
    attrs: {
      "placeholder": "Celular"
    },
    model: {
      value: (_vm.responsible.phone),
      callback: function($$v) {
        _vm.$set(_vm.responsible, "phone", $$v)
      },
      expression: "responsible.phone"
    }
  }), _vm._v(" "), (_vm.$v.responsible.phone.$invalid) ? _c('span', {
    staticClass: "error-message"
  }, [_vm._v("El teléfono es requerido")]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5625cdfc","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/buy/responsibleForm.vue
// module id = 1120
// module chunks = 32